import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type DetailsApp from './index.tsx';

export default lazyForPaint<typeof DetailsApp>(
	() => import(/* webpackChunkName: "async-project-settings-details" */ './index'),
);
